import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./consumo-listar/consumo-listar.module').then(m => m.ConsumoListarModule) },
    { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./consumo-inserir/consumo-inserir.module').then(m => m.ConsumoInserirModule) },
    { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./consumo-editar/consumo-editar.module').then(m => m.ConsumoEditarModule) },
    { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./consumo-detalhar/consumo-detalhar.module').then(m => m.ConsumoDetalharModule) }



  ])],
  exports: [RouterModule]
})
export class ConsumoRoutingModule { }
